import { render, staticRenderFns } from "./VideoCallCloseSvg.vue?vue&type=template&id=77122b2b&scoped=true"
import script from "./VideoCallCloseSvg.vue?vue&type=script&lang=js"
export * from "./VideoCallCloseSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77122b2b",
  null
  
)

export default component.exports